import React from 'react';
import QuestionDetail from '../components/Review/QuestionDetail';

const SurveyAssessmentQuestionDetailContainer = (props) => {
  return <QuestionDetail {...props} />;
};

export default SurveyAssessmentQuestionDetailContainer;
